import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Button from 'portal-modules/common/components/Button'
import { RpModal } from 'portal-modules/common/components/modals'
import PropTypes from 'prop-types'

import {
  showCancelPaymentSuccess,
  showLoader,
} from 'portal-modules/common/redux/modules/toggleSuccessModals'
import { FullscreenLoader } from 'portal-modules/common/components/loaders'

import styled from '@emotion/styled'
import { css } from '@emotion/core'

const StyledSpan = styled('span')`
  font-size: 14px;
`

const StyledCancelPaymentText = styled('div')`
  max-height: 280px;
  overflow: auto;
`

const btnStyle = css`
  span > {
    text-decoration: none;
  }
`

const CustomButton = ({ text, appearance, onClick }) => (
  <Button
    appearance={appearance}
    onClick={onClick}
    size='medium'
    fullWidth
  >
    {text}
  </Button>
)

const CancelPaymentModal = props => {
  const {
    onClose,
    paymentIds,
    showLoader,
    isShowLoader,
    showCancelPaymentSuccess,
    paymentCancel,
    ...rest
  } = props
  return (
    <RpModal
      // title={__('Cancel Payment')}
      {...rest}
      footerContent={
        <Fragment>
          <CustomButton
            text={__('No, Keep My Payment')}
            appearance='primary'
            onClick={onClose}
          />
          <CustomButton
            text={__('Yes, Cancel My Payment')}
            appearance='secondary'
            onClick={() => {
              showLoader(__('Cancelling Payment'))
              paymentCancel({
                payload: { payment_ids: paymentIds },
                callback: success => {
                  onClose()
                  if (success) {
                    showCancelPaymentSuccess(true)
                  }
                },
              })
            }}
          />
        </Fragment>
      }
    >
      <Fragment>
        <FullscreenLoader show={!!isShowLoader}>
          {isShowLoader}
        </FullscreenLoader>
        <StyledCancelPaymentText>
          <StyledSpan>
            {__(
              'If this payment is cancelled, any charges paid will be outstanding again. Are you sure you want to continue with cancelling this payment?',
            )}
          </StyledSpan>
        </StyledCancelPaymentText>
      </Fragment>
    </RpModal>
  )
}

CancelPaymentModal.propTypes = {
  onClose: PropTypes.func,
  paymentIds: PropTypes.array,
  paymentCancel: PropTypes.func,
  showLoader: PropTypes.func,
  history: PropTypes.object,
  isShowLoader: PropTypes.string,
  showCancelPaymentSuccess: PropTypes.func,
}

export default connect(
  ({ userModuleModals: { showLoader } }) => ({ isShowLoader: showLoader }),
  { showLoader, showCancelPaymentSuccess },
)(CancelPaymentModal)
